export default __webpack_public_path__ + "static/media/NIE_touchpoint_05.1e16e8d4.mp4";